import { TextSize, Weight } from 'components'

import { GLOBAL_COLORS } from 'theme'
import styled from 'styled-components'

export const PageContainer = styled.div`
  display: flex;
  margin-top: 90px;
  flex-direction: column;
  gap: 60px;
  font-size: ${TextSize.small};
  font-weight: ${Weight.Regular};
  line-height: 130%;
  padding-bottom: 60px;
  ${({ theme }) => theme.mediaWidth.Mobile`
    width: calc(100% - 80px);
    margin: 0 auto;
`};
`

export const Title = styled.span`
  font-size: ${TextSize.h4};
  font-weight: ${Weight.Bold};
  line-height: 110%;
  letter-spacing: -0.8px;
`

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

export const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
`

export const SectionTitle = styled.span`
  font-size: ${TextSize.two};
  font-weight: ${Weight.Medium};
  line-height: 27.158px;
`

export const SectionContent = styled.span`
  opacity: 0.6;
`

export const SectionList = styled.ul`
  padding-left: 25px;
`

export const SectionLink = styled.a`
  color: ${GLOBAL_COLORS.coralBlue};
  transition: 0.3s opacity;
  &:hover {
    opacity: 0.8;
  }
  &:active {
    opacity: 0.6;
  }
  text-decoration: none;
`
